<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="statDateDay"
                    label="统计时间"
                >
                    <el-date-picker
                        :picker-options="$utils.CommonConfig.pickerOptions"
                        v-model="queryFormModel.statDateDay"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    />
                </el-form-item>
                <el-form-item
                    prop="paymentType"
                    label="付款方式"
                >
                    <RemoteSelect
                        clearable
                        remote="/sp/shop/getShopPrepaidPaymentTypeList"
                        placeholder="请输入"
                        :props="{id:'id',name:'name'}"
                        v-model="queryFormModel.paymentType"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>

            <el-row
                class="second-header bc-t npa-a"
                :gutter="12"
            >
                <el-col :span="12">
                    <el-card
                        shadow="hover"
                        :body-style="{ padding: '0px' }"
                    >
                        <div class="small-card">
                            <div class="icon bc-main tc-w">
                                <div class="f-icon">
                                    &#xf02c;
                                </div>
                                <div class="label">
                                    合计
                                </div>
                            </div>
                            <div class="body">
                                <div class="">
                                    订单数量
                                </div>
                                <div class="fs-more fw-bold">
                                    {{ buyerPrepaidOrderStat.orderNum || 0 }}
                                </div>
                            </div>
                            <div class="body">
                                <div class="">
                                    实付金额
                                </div>
                                <div class="fs-more fw-bold">
                                    {{ buyerPrepaidOrderStat.payableAmount || 0 }}
                                </div>
                            </div>
                            <div class="body">
                                <div class="">
                                    充值金额
                                </div>
                                <div class="fs-more fw-bold">
                                    {{ buyerPrepaidOrderStat.prepaidAmount || 0 }}
                                </div>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
            >
                <el-table-column
                    type="index"
                    width="50"
                />
                <el-table-column
                    prop="userName"
                    label="用户名"
                    min-width="60"
                />
                <el-table-column
                    prop="mobile"
                    label="手机号"
                    min-width="60"
                />
                <el-table-column
                    prop="paymentSn"
                    label="付款单号"
                    min-width="60"
                />
                <el-table-column
                    label="付款时间"
                    min-width="60"
                >
                    <template slot-scope="scope">
                        {{ scope.row.paymentTime | moment('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="payableAmount"
                    label="实付金额"
                    min-width="30"
                />
                <el-table-column
                    prop="prepaidAmount"
                    label="充值金额"
                    min-width="30"
                />
                <el-table-column
                    prop="paymentTypeName"
                    label="付款方式"
                    min-width="30"
                >
                    <template slot-scope="scope">
                        {{ scope.row.paymentTypeName }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="paymentComments"
                    label="付款备注"
                    min-width="60"
                />
                <el-table-column
                    label="付款凭证"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <ImageList
                            :data="scope.row.payVoucherList"
                        />
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'BuyerPrepaidOrderStatList',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                buyerId: '',
                statDateDay: '',
                paymentType: '',
            },
            // 表格数据
            tableData: [],
            buyerPrepaidOrderStat: {},
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Stat.PrepaidCardStat.buyerPrepaidOrderStatList(queryData).then(json => {
                const res = json.data.data.orderList;
                this.tableData = res.data;
                this.pagination = res.pagination;

                this.buyerPrepaidOrderStat = json.data.data.buyerPrepaidOrderStat;
                return Promise.resolve({ data: res });
            });
        },
    },
    created() {
        this.queryFormModel.statDateDay = [this.$utils.getSysDayDate(), this.$utils.getSysDayDate()];
    },
};
</script>

<style lang="scss" scoped>
</style>
